export const SIZE_VALUES = [
  'flush',
  'tiny',
  'small',
  'large',
  'huge'
]

export const SPACE_VALUES = [
  'around',
  'between',
  'center',
  'end'
]

export const VALIGN_VALUES = [
  'middle',
  'bottom'
]

export const ALIGN_VALUES = [
  'left',
  'right'
]



// WEBPACK FOOTER //
// ./src/constraints.js